import { Col, ControlLabel, FormGroup, Row } from "react-bootstrap";
import { compose, pure, withHandlers, withState } from "recompose";

import Card from "../Card/Card.jsx";
import Checkbox from "../../elements/CustomCheckbox/CustomCheckbox.jsx";
import FixedAlertTextInfo from "../../elements/NotificationContent/FixedAlertTextInfo.jsx";
import { FormattedMessage } from "react-intl";
import Queries from "../../queries/queries2";
import React from "react";
import TaxSelect from "./TaxSelect";
import _ from "lodash";
import { graphql } from "react-apollo";

import Select from "react-select-plus";

const forbiddenLabels = withState(
  "forbiddenLabels",
  "setForbiddenLabels",
  ({ tax1, tax2 }) => {
    return [tax1 && tax1.label, tax2 && tax2.label];
  }
);

const idemLoaded = withState("idemLoaded", "setIdemLoaded", false);

const handlers = withHandlers({
  onIdemCheck: ({ defaultTaxes, onChange, setIdemLoaded }) => value => {
    if (value) {
      onChange("tax1", defaultTaxes.company.tax1);
      onChange("tax2", defaultTaxes.company.tax2);
      onChange("taxIdemCompany", true);
      setIdemLoaded(true);
    } else {
      onChange("taxIdemCompany", false);
    }
  }
});

const TaxParamsCard = ({
  taxHolder,
  sendNotification,
  companyId,
  tax1,
  tax2,
  onChange,
  withIdemCheckBox,
  taxIdemCompany,
  setIdem,
  onIdemCheck,
  blockCreateOnTaxes,
  setForbiddenLabels,
  forbiddenLabels,
  defaultTaxes,
  idemLoaded,
  taxableValue,
  intl
}) => {

  // console.log("54 - defaultTaxes=", defaultTaxes);
  // if (defaultTaxes.loading)
  //   return <div></div>;


  if (!idemLoaded && taxIdemCompany && !tax1 && !tax2) {
    onIdemCheck(true);
  }
  // console.log("tax1:", tax1)
  // console.log("tax2:", tax2)
  const tax1ForbiddenLabels = tax1
    ? _.difference(forbiddenLabels, [tax1.label])
    : forbiddenLabels;
  const tax2ForbiddenLabels = tax2
    ? _.difference(forbiddenLabels, [tax2.label])
    : forbiddenLabels;

  let selectedValued = taxableValue;

  if (intl) {
    var options =
      [
        // {
        //   value: "TAXABLE",
        //   label: intl.formatMessage({ id: "ids_taxable" })
        // },
        {
          value: "NON_TAXABLE",
          label: intl.formatMessage({ id: "ids_nonTaxable" })
        },
        {
          value: "ENCAISSEMENT",
          label: intl.formatMessage({ id: "ids_encaissement" })
        },
        {
          value: "SUR_LES_DEBITS",
          label: intl.formatMessage({ id: "ids_debit" })
        },
        {
          value: "A_L_EXPORT",
          label: intl.formatMessage({ id: "ids_aLExport" })
        },
        {
          value: "INTRACOMMUNAUTAIRE",
          label: intl.formatMessage({ id: "ids_intracommunautaire" })
        },
        {
          value: "AUTO_LIQUIDATION",
          label: intl.formatMessage({ id: "ids_autoLiquidation" })
        }
      ];
  }

  return (
    <Card title={<FormattedMessage id="ids_taxByDefaultLabel" />}>

      <Row>
        <Col xs={6}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_tax1" />
            </ControlLabel>
            <TaxSelect
              creatable={!blockCreateOnTaxes}
              forbiddenLabels={tax1ForbiddenLabels}
              sendNotification={sendNotification}
              companyId={companyId}
              value={tax1 && tax1.id}
              onSelected={e => {
                console.log("onSelected", e);
                if (withIdemCheckBox && taxIdemCompany) {
                  onChange("taxIdemCompany", false);
                }
                setForbiddenLabels([e && e.element.label, tax2 && tax2.label]);
                onChange("tax1", e && e.element);
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_tax2" />
            </ControlLabel>
            <TaxSelect
              creatable={!blockCreateOnTaxes}
              forbiddenLabels={tax2ForbiddenLabels}
              sendNotification={sendNotification}
              companyId={companyId}
              value={tax2 && tax2.id}
              onSelected={e => {
                console.log("onSelected", e);
                if (withIdemCheckBox && taxIdemCompany) {
                  onChange("taxIdemCompany", false);
                }
                setForbiddenLabels([tax1 && tax1.label, e && e.element.label]);
                onChange("tax2", e && e.element);
              }}
            />
          </FormGroup>
        </Col>
        {withIdemCheckBox ? (
          <Col xs={12}>
            <FormattedMessage id="ids_TVAByDefaultFormMyCompany">
              {label => (
                <Checkbox
                  number="1000"
                  isChecked={taxIdemCompany}
                  label={label}
                  onCheck={value => {
                    // console.log("119 - click", value);
                    onIdemCheck(value)
                  }}
                />
              )}
            </FormattedMessage>
            <FormattedMessage id="ids_TaxIdemCompanyDescription">
              {placeholder => <FixedAlertTextInfo text={placeholder} />}
            </FormattedMessage>
          </Col>
        ) : (
          <div />
        )}
      </Row>

      {intl ? (
        <Row>
          <br />
          <br />
          <Col xs={6}>
            <FormGroup>
              <ControlLabel>
                <FormattedMessage id="ids_taxable" />
              </ControlLabel>

              <Select
                clearable={false}
                value={selectedValued}
                onChange={e => {
                  onChange("taxableValue", e && e.value);
                }}
                options={options}
              />
            </FormGroup>
          </Col>
        </Row>
      ) : (<div></div>)
      }
    </Card>
  );
};

export default compose(
  graphql(Queries.GET_COMPANY_DEFAULT_TAXES, { name: "defaultTaxes" }),
  forbiddenLabels,
  idemLoaded,
  handlers,
  pure
)(TaxParamsCard);
